
import React, {useEffect} from 'react';
import './App.scss';
import Header from '../Header/Header.js';

import UnderHeader from '../UnderHeader/UnderHeader.js';

import Menu from '../Menu/Menu.js';
import Footer from '../Footer/Footer.js';
import DevPage from '../DevPage/DevPage.js';
import MainView from '../MainVIew/MainView.js';
import Admin from '../Admin/Admin.js';
//auth
import FirstMain from '../FirstMain/FirstMain.js';


import { refreshToken } from '../Authorization/authSlice.js';
//..
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RecoveryPass from '../Authorization/RecoveryPass/RecoveryPass.js';

//import { userAnswerRight, userAnswerWrong, nextQuestion, getResult } from '../MainVIew/Quiz/quizSlice.js';
import { openAdminView, closeAdminView } from '../Admin/adminSlice.js';



const App = (props) => {
  const { state, dispatch } = props;
  
  const token = localStorage.getItem('token');
//auth
    //CHECK AUTHORIZATION
   
    useEffect(() => {
     
    // const controller = new AbortController();  //LEARN ABORT CONTROLLER!!!!

      if (localStorage.getItem('token')) {

        console.log( "TOKEN EXIST IN LOCALSTORAGE");
        dispatch(refreshToken());

         //dispatch(refreshToken({signal: controller.signal}));

    //  return () => controller.abort();  
                            
      } else {
        console.log( "TOKEN dosnt EXIST ");
        
      }
      
  },[dispatch]);
  //..

/*
    useEffect(() => {
     // const { state, dispatch } = props;
      if (localStorage.getItem('token')) {

        console.log( "TOKEN EXIST IN LOCALSTORAGE");

    const refreshTokenFunction = async () => {
      try {
        // 2. Await your asynchronous dispatch
        const answer = await dispatch(refreshToken()).unwrap();
        console.log(answer);
      } catch (error) {
        console.error("Failed to load user data:", error);
      }
    };

    // 3. Call the function immediately
    refreshTokenFunction();


      } else {
        console.log( "TOKEN dosnt EXIST ");
        
      }
      
  },[dispatch]);

*/








// ADMIN COMPONENT
//CLOSE ADMIN COMPONENT
const closeAdminViewHandler = () => {
  const {dispatch} = props;
  dispatch(closeAdminView());
  //setAdminView(false);

}

const renderAdmin = () => {
 
  const { state, dispatch } = props;
 // console.log(state.admin);
     return (
      <Admin 
      adminUsersState={state.adminUsers}
      adminState={state.admin}
      
      authData={state.auth}
      dispatch={dispatch}
      libraryData={state.library}
      tasksDataMain = {state.tasksMain}
      closeAdminView={closeAdminViewHandler} // не используется нигде
      />
        )
}
//SHOW ADMIN COMPONENT
const handlerAdminView = () => {
      //setAdminView(true);
      const {dispatch} = props;
      dispatch(openAdminView());
}




const renderAuthPage = authCondition => {
 // console.log('renderAuthPage');
  
    return (
      <BrowserRouter>
        <div>
          <Routes>
             <Route path="/" element={<FirstMain
            dispatch={dispatch}
            userData={state.auth}
            getData={state.user}
            />} />
            
            <Route path="*" element={<FirstMain
            dispatch={dispatch}
            userData={state.auth}
            getData={state.user}
            />} />


            
            
            <Route path="/api/auth/recoverypass/reset" element={<RecoveryPass
            dispatch={dispatch}
            userData={state.auth}
            getData={state.user}
            />} />
            
            </Routes>
        </div>
      </BrowserRouter>
          
    )  
  
}


 const renderDevPage = () => {
  
  
    return (
      <div>
          <DevPage
          dispatch={dispatch}
          userData={state.auth}
          getData={state.user}
          />
      </div>
          
    ) 
  
 }

const renderMainView = viewParam => {
  if (!viewParam) {
    return (
      <div className="App">
           <Header 
             adminViewChange={handlerAdminView}
             userRole={state.auth.userRole}
             dispatch={dispatch}
           />

           <UnderHeader
           authData={state.auth}
           dispatch={dispatch}
           />



           <Menu 
            accountData={state.account}
            authData={state.auth}
            dispatch={dispatch}
            messagesData={state.messages}
            selectedModule={state.menuSide.selectedModule}
            menuSideView ={state.menuSide.menuSideView}
           
           />
           <MainView 
              authData={state.auth}
              menuSide={state.menuSide}
              dispatch={dispatch}
              quizViewChangeRedux={state.quiz}
              //onAnswerSelected={handleAnswerSelected}
              //nextQuestion={setNextQuestion}
              accountData={state.account}
              libraryData={state.library}
              dataNotes={state.admin.dataNotes}
              notesDataSlice={state.notes}
              messagesData={state.messages}
              contactsStore = {state.contacts}
              troublesData = {state.troubles}
              dataTroubles = {state.admin.dataTroubles}
              dataAnswerTroubles = {state.admin.dataAnswerTroubles}
              tasksDataMain = {state.tasksMain}
              noteAddFiles = {state.admin.noteAddFiles}
              adminPdfViewer= {state.admin.adminPdfViewer}
              pdfName = {state.admin.pdfName}
              selectedIdAnswerTrouble={state.admin.selectedIdAnswerTrouble}
              selectedIdTrouble={state.admin.selectedIdTrouble}

           />
          
           <Footer />
      </div>
    )
    } else {
      return (
        <div className="App">

        <Header 
         adminViewChange={handlerAdminView}
         userRole={state.auth.userRole}
         dispatch={dispatch}
        /> 
        <UnderHeader
        authData={state.auth}
        dispatch={dispatch}
           /> 

        {renderAdmin()}

        </div>
      );
    }

  }    
  
//RENDER RULES











//NOT CLEAR FUNCTION!!!!!!
const renderAppMain = ( authStatus, adminViewFirstly) => {
console.log( adminViewFirstly);
 
 if (!authStatus) {                                 // NO USER ID
    console.log('render auth form');
    return renderAuthPage();
  }
   
 if (localStorage.getItem('token')) {         //CHECK TOKEN SIGNATURE

    //console.log( "TOKEN EXIST IN LOCALSTORAGE");

   // refreshTokenFunction();
    
   
    
    console.log('render main form');
    console.log(state.auth.isFetchingStatusForRefresh);

    return renderMainView(adminViewFirstly); 

  }
    else {                                         // NO TOKEN
      return renderAuthPage();
  }
  

}


// RETURN APP
const developmentStage = false; // FALSE if stage deploy, true -development
//console.log(state.admin.adminView);
//console.log(typeof(state.auth.id));
console.log(state.auth);

if (developmentStage) {
   return renderDevPage();
} else {

  console.log(state.auth.isFetchingStatusForRefresh);
  console.log(state.auth.id);
if (state.auth.isFetchingStatusForRefresh) return renderAppMain(state.auth.id, state.admin.adminView ); //RENDER MAIN ONLY AFTER REFRESH TOKEN
if (!token) return renderAuthPage();  //IF TOKEN NO
//if (!state.auth.isFetchingStatusForRefresh && token) return renderAuthPage();
}



}
export default App;

